import { render, staticRenderFns } from "./attrLabel.vue?vue&type=template&id=7c501aa3&scoped=true&"
import script from "./attrLabel.vue?vue&type=script&lang=js&"
export * from "./attrLabel.vue?vue&type=script&lang=js&"
import style0 from "./attrLabel.vue?vue&type=style&index=0&id=7c501aa3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c501aa3",
  null
  
)

export default component.exports